import * as React from 'react';
import { connect } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import Auth from '../auth';
import { confirmarMfaApi, loginApi, enlazarMfaUsuarioApi, postSearchUsuario } from '../api/axios'
import { setAuthenticated, setIdSeller, setUserName, setUserCredenciales, setMfaStatus } from '../actions/generalActios'
import { fetchTokenResetPassword, userTypeIds } from '../actions/usuariosActions';
import MiniSpinner from "./General/MiniSpinner";
import { GoogleReCaptcha, withGoogleReCaptcha } from "react-google-recaptcha-v3";
import { toast } from 'react-toastify';
import { encryptPassword } from '../utilities/encryptPassword';
import './Login.css';

// Wrapper para usar hooks en class component y el Provider de ReCaptcha

class Login extends React.Component {
    constructor(props) {
        super(props);
        //this._SolveReCaptcha = false; //process.env.NODE_ENV === "production"; //desarrollo - no olvidar el appsettings.json que apunta a desarrollo con su score
        this._SolveReCaptcha = true; //produccion - no olvidar el appsettings.json que apunta a produccion con su score
        this.state = {
            user: '',
            email: '',
            password: '',
            errorMessage: '',
            showSpinner: false,
            recoverPassword: false,
            showPassword: false,
            mFaHabilitado: false,
            mfaConfirmado: false,
            showInputMFaHabilitado: false,
            esperandoCodigoDobleAutenticacion: false,
            codigoDobleAutenticacion: "",
            errorCodigoDobleAutenticacion: "",

            // New MFA Flow State
            showMfaPrompt: false,
            showMfaSetup: false,
            codigoQR: null,
            mfaSetupCode: "",
            mfaSetupError: "",
            loginResponseData: null,
        }
    }

    componentDidMount() {
        this.setState({ recoverPassword: false });
    }

    componentDidUpdate(prevProps) {
        const key = this.props.location?.key;
        if (key != null && key !== prevProps.location?.key) {
            this.setState({ recoverPassword: false });
        }
    }

    handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "codigoDobleAutenticacion") {
            const soloNumeros = value.replace(/\D/g, "");
            this.setState({ codigoDobleAutenticacion: soloNumeros });
        } else if (name === "mfaSetupCode") {
            const soloNumeros = value.replace(/\D/g, "");
            this.setState({ mfaSetupCode: soloNumeros });
        } else {
            this.setState({ [name]: value });
        }
    }

    onRequestToken = (event) => {
        if (event?.preventDefault) event.preventDefault();
        this.setState({ showSpinner: true });

        this.props.fetchTokenResetPassword(this.state.email)
            .then(() => {
                this.setState({ recoverPassword: false });
                toast.success("Se enviará un mail al correo del usuario con un token temporal para que pueda ingresar");
            })
            .catch((err) => {
                const errores = err?.response?.data?.errores || ["No pudo enviarse el token"];
                errores.forEach(error => toast.error(error));
            })
            .finally(() => {
                this.setState({ showSpinner: false });
            });
    };

    handleFormSubmit = (e) => {
        e.preventDefault();
        if (this.state.recoverPassword) {
            return;
        }
        this.onLogin(e);
    };

    onLogin = async (e) => {
        e.preventDefault();
        if (this.state.submitted) return;

        this.setState({ submitted: true, showSpinner: true });

        let tokenReCaptcha = "";

        if (this._SolveReCaptcha) {
            const executeRecaptcha = this.props.googleReCaptchaProps?.executeRecaptcha;
            if (!executeRecaptcha) {
                this.setState({
                    errorMessage: "El servicio de ReCaptcha no está disponible. Intente nuevamente.",
                    showSpinner: false,
                    submitted: false
                });
                return;
            }

            try {
                tokenReCaptcha = await executeRecaptcha("login");
            } catch (error) {
                console.error("Error executing reCAPTCHA", error);
                this.setState({
                    errorMessage: "Error al validar ReCaptcha. Intente nuevamente.",
                    showSpinner: false,
                    submitted: false
                });
                return;
            }

            if (!tokenReCaptcha) {
                this.setState({
                    errorMessage: "No se pudo obtener el token de ReCaptcha. Intente nuevamente",
                    showSpinner: false,
                    submitted: false
                });
                return;
            }
        }

        const { user, password, codigoDobleAutenticacion } = this.state;

        let requestLogin = {
            Usuario: user,
            Password: encryptPassword(password),
            codigo: codigoDobleAutenticacion,
            idConexion: "string",
            TokenCaptcha: tokenReCaptcha
        }


        let req = loginApi(requestLogin);

        this.props.setUserCredenciales(user, encryptPassword(password))

        req.then(async (res) => {
            const { mfaHabilitado, mfaConfirmado, tipoUsuario, fechaUltimoLogin, mfaBypass } = res;

            this.props.setMfaStatus(mfaHabilitado, mfaConfirmado, this.state.codigoDobleAutenticacion);



            // Si es un usuario que debe resetear password (tipo 5)
            if (tipoUsuario == userTypeIds.isResetPassword) {

                this.completeLogin(res);
                return;
            }

            // Bypass MFA: solo si el BFF marca mfaBypass (SecurityOverrides:MfaBypassUserIds en appsettings)
            if (mfaBypass) {
                this.completeLogin(res);
                return;
            }

            if ((mfaHabilitado === false && mfaConfirmado === false) ||
                (mfaHabilitado === true && mfaConfirmado === false)) {

                // Interceptar inicio de sesión si MFA no está habilitado/confirmado
                this.setState({
                    loginResponseData: res,
                    showMfaPrompt: true,
                    submitted: false,
                    showSpinner: false
                });

            } else if (mfaHabilitado === true && mfaConfirmado === true) {
                this.setState({
                    submitted: false,
                    esperandoCodigoDobleAutenticacion: true,
                    showInputMFaHabilitado: true,
                    showSpinner: false,
                });

                if (this.state.codigoDobleAutenticacion.length === 6) {
                    this.completeLogin(res);
                }
            }


        }).catch(err => {
            let errorMsg = "Error de autenticación";


            if (err?.response?.status === 400 && this.state.esperandoCodigoDobleAutenticacion) {
                errorMsg = "El código de segundo factor de autenticación es inválido";
                this.setState({
                    errorMessage: "",
                    errorCodigoDobleAutenticacion: errorMsg,
                    submitted: false,
                    showSpinner: false,
                    codigoDobleAutenticacion: "",
                });
            } else {
                // Manejo de otros errores
                // Si la API devuelve un array de errores directamente
                if (Array.isArray(err?.response?.data)) {
                    err.response.data.forEach(error => toast.error(error));
                    this.setState({
                        errorMessage: "",
                        submitted: false,
                        showSpinner: false,
                    });
                    return;
                }
                // Errores del backend como array de strings en propiedad 'errores'
                if (err?.response?.data?.errores) {
                    const errores = err.response.data.errores;
                    errores.forEach(error => toast.error(error));
                    this.setState({
                        errorMessage: "",
                        submitted: false,
                        showSpinner: false,
                    });
                    return;
                }

                this.setState({
                    errorMessage: "",
                    submitted: false,
                    showSpinner: false,
                });
            }


        });
    }

    completeLogin = async (res) => {
        const { idSeller, nombre, tipoUsuario, userId, hiddenItemsIds, fechaUltimoLogin, mfaConfirmado, mfaHabilitado, canImpersonate } = res;
        let { codProv } = res;

        // Se detecta usuario en proceso de reset si:
        // 1. Es un usuario existente (fechaUltimoLogin).
        // 2. Tiene MFA Confirmado en FALSE.
        // 3. Tiene MFA Habilitado en FALSE (esto lo distingue de usuarios normales pendientes de configurar MFA).
        const isUsuarioExistenteConResetPendiente = mfaHabilitado === false && mfaConfirmado === false && fechaUltimoLogin;

        const isResetPassword = tipoUsuario == userTypeIds.isResetPassword;

        // ID efectivo del usuario — puede ser 0 si el login API no lo devuelve correctamente (ej. Contaduria tipo 8)
        let effectiveUserId = userId;

        // Si estamos en modo reset y el userId vino como 0/vacío, buscar el ID real por username
        if (isResetPassword && (!effectiveUserId || effectiveUserId === 0)) {
            try {
                const userResponse = await postSearchUsuario({ nombreUsuario: this.state.user || this.state.email });
                if (userResponse.data && userResponse.data.usuario && userResponse.data.usuario.length > 0) {
                    effectiveUserId = userResponse.data.usuario[0].idUsuario || userResponse.data.usuario[0].IdUsuario || 0;
                }
            } catch (error) {
                // Si falla la búsqueda, continuar con userId=0 y dejar que UserEdit maneje el fallback
            }
        }

        const redirectTo = isResetPassword
            ? `/Usuarios/Editar/${effectiveUserId}`
            : `/`;

        // Si codProv no vino en el login, lo buscamos en el detalle del usuario
        if (!codProv && tipoUsuario !== userTypeIds.isResetPassword) {
            try {
                // Se busca por nombreUsuario como solicitó el usuario
                const userResponse = await postSearchUsuario({ nombreUsuario: this.state.user });
                if (userResponse.data && userResponse.data.usuario && userResponse.data.usuario.length > 0) {
                    const userObj = userResponse.data.usuario[0];
                    // Intenta con idProveedor (camel) o IdProveedor (pascal)
                    codProv = userObj.idProveedor || userObj.IdProveedor;
                }
            } catch (error) {
                // Silently handle error
            }
        }

        Auth.login(idSeller, nombre, tipoUsuario, effectiveUserId, hiddenItemsIds, codProv, null, canImpersonate);
        this.setState({ submitted: false, showSpinner: false });

        if (isResetPassword) {
            this.props.navigate(redirectTo, {
                state: {
                    isResetMode: true,
                    resetToken: this.state.password,
                    username: this.state.user || this.state.email // Pass the input user/email
                }
            });
        } else {
            this.props.navigate(redirectTo);
        }
    }

    handleStartMfaSetup = () => {
        this.setState({ showSpinner: true });
        const { userId } = this.state.loginResponseData;
        const { user, password } = this.state;

        let requestEnlazarMfa = {
            idUsuario: userId,
            usuario: user,
            password: encryptPassword(password)
        };

        enlazarMfaUsuarioApi(requestEnlazarMfa)
            .then((res) => {
                this.setState({
                    codigoQR: res.codigoQrEnlace,
                    showMfaSetup: true,
                    showMfaPrompt: false,
                    showSpinner: false
                });
            })
            .catch(err => {
                toast.error("Error al iniciar configuración MFA");
                this.setState({ showSpinner: false });
            });
    }

    handleConfirmMfaSetup = () => {
        const { userId } = this.state.loginResponseData;
        const { mfaSetupCode } = this.state;

        if (!mfaSetupCode || mfaSetupCode.length !== 6) {
            this.setState({ mfaSetupError: "El código debe tener 6 dígitos" });
            return;
        }

        const requestConfirmarMfa = {
            idUsuario: userId,
            codigo: mfaSetupCode,
        };

        this.setState({ showSpinner: true, mfaSetupError: "" });

        confirmarMfaApi(requestConfirmarMfa)
            .then(() => {
                toast.success("MFA configurado correctamente");
                this.props.setMfaStatus(true, true);
                this.completeLogin(this.state.loginResponseData);
            })
            .catch((error) => {
                this.setState({
                    showSpinner: false,
                    mfaSetupError: "Código incorrecto. Intente nuevamente."
                });
            });
    }

    togglePasswordVisibility = () => {
        if (this.state.password.length === 0) {
            toast.warn("Ingrese contraseña");
            return;
        }
        this.setState(prevState => ({ showPassword: !prevState.showPassword }));
    };

    handleVerifyReCaptcha = (token) => {
        if (this.state.setTokenReCaptcha) {
            this.verifyReCaptcha(token);
        }
    }

    render() {
        const { showSpinner, recoverPassword, showInputMFaHabilitado, codigoDobleAutenticacion, showMfaPrompt, showMfaSetup, codigoQR, mfaSetupCode, mfaSetupError } = this.state;

        const IconEye = (isHidden) => (
            <i className={`mdi mdi-eye${isHidden ? "" : "-off"} mdi-24px`} />
        );

        return (
            <section className="login-screen">
                <div className="login-screen__ambient login-screen__ambient--primary" />
                <div className="login-screen__ambient login-screen__ambient--secondary" />
                <div className="login-shell row justify-content-center align-items-stretch g-0">
                    <div className="col-12 col-lg-4">
                        <div className="login-hero">
                            <span className="login-hero__badge">Marketplace Megatone</span>
                            <img className="login-hero__logo" src="/img/logo-marketplace-megatone.png" alt="Marketplace Megatone" />
                            
                            <h1 className="login-hero__title">
                                {recoverPassword ? "Recuperación de acceso" : "Acceso Seller Center"}
                            </h1>
                            <p className="login-hero__text">
                                {recoverPassword
                                    ? "Solicita una nueva clave temporal para retomar el acceso de forma segura."
                                    : "Ingresa con tus credenciales para operar publicaciones, órdenes, rebates, liquidaciones, todo desde un único lugar."}
                            </p>
                            <div className="login-hero__highlights">
                                <div className="login-hero__highlight">Acceso seguro</div>
                                <div className="login-hero__highlight">Operación centralizada</div>
                                <div className="login-hero__highlight">Soporte Doble Factor</div>
                            </div>
                        </div>
                    </div>

                    <div className="login-box card col-12 col-lg-8">
                        <div className="card-body login-box__body">
                            <form className="form-horizontal form-material login-form" id="loginform" onSubmit={this.handleFormSubmit}>

                                <div className="login-brand">
                          
                                    <div className="login-brand__copy">
                                        <span className="login-brand__eyebrow">Login Seller Center</span>
                                        <h2 className="login-brand__title">
                                            {recoverPassword
                                                ? "Solicitar nueva contraseña"
                                                : showMfaSetup
                                                    ? "Vincular autenticador"
                                                    : showMfaPrompt
                                                        ? "Activar doble factor"
                                                        : showInputMFaHabilitado
                                                            ? "Confirmar segundo factor"
                                                            : "Ingresar a la plataforma"}
                                        </h2>
                                        <p className="login-brand__subtitle">
                                            {recoverPassword
                                                ? "Ingresá el correo del usuario y enviamos un acceso temporal."
                                                : showMfaSetup
                                                    ? "Escaneá el código QR y validá el código para completar la configuración."
                                                    : showMfaPrompt
                                                        ? "Recomendamos activarlo ahora para proteger mejor tu cuenta."
                                                        : showInputMFaHabilitado
                                                            ? "Usá el código generado por tu aplicación de autenticación."
                                                            : "Accedé con tus credenciales para continuar."}
                                        </p>
                                    </div>
                                </div>

                                {!recoverPassword ?
                                    <div className="login-form__content">
                                        {/* MFA Prompt UI */}
                                        {showMfaPrompt ? (
                                            <div className="text-center">
                                                <h4 className="mb-3">Configuración de Doble Factor</h4>
                                                <p>Para mejorar la seguridad de tu cuenta, te recomendamos activar el doble factor de autenticación.</p>

                                                <button
                                                    type="button"
                                                    className="btn btn-block background-rojo-megatone w-100 mb-2"
                                                    onClick={this.handleStartMfaSetup}
                                                >
                                                    Configurar ahora
                                                </button>

                                                <a
                                                    href="/manual_mfa.html"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn btn-outline-secondary w-100 mb-2"
                                                >
                                                    <i className="mdi mdi-help-circle-outline me-1"></i>
                                                    Ayuda para configurar
                                                </a>
                                            </div>
                                        ) : showMfaSetup ? (
                                            <div className="text-center">
                                                <h5 className="mb-3">Escaneá el código QR</h5>
                                                {codigoQR && (
                                                    <img
                                                        src={`data:image/png;base64,${codigoQR}`}
                                                        alt="QR de autenticación"
                                                        style={{ width: 200, height: 200 }}
                                                        className="mb-3"
                                                    />
                                                )}
                                                <p className="small text-muted">
                                                    Usá una app como Microsoft Authenticator o Google Authenticator.
                                                </p>

                                                <input
                                                    required
                                                    name="mfaSetupCode"
                                                    type="text"
                                                    className="form-control mb-3 text-center"
                                                    placeholder="Ingresá el código de 6 dígitos"
                                                    onChange={this.handleChange}
                                                    maxLength={6}
                                                    value={mfaSetupCode}
                                                />
                                                {mfaSetupError && <small className="text-danger d-block mb-2">{mfaSetupError}</small>}

                                                <button
                                                    type="button"
                                                    className="btn btn-block background-rojo-megatone w-100"
                                                    onClick={this.handleConfirmMfaSetup}
                                                >
                                                    Confirmar
                                                </button>

                                                <button
                                                    type="button"
                                                    className="btn btn-link w-100 mt-2"
                                                    onClick={() => this.setState({ showMfaSetup: false, showMfaPrompt: true })}
                                                >
                                                    Cancelar
                                                </button>
                                            </div>
                                        ) : (
                                            // Normal Login UI
                                            <>
                                                <div className="form-group">
                                                    <div className="col-12">
                                                        <label className="login-form__label">Usuario</label>
                                                        <input
                                                            required
                                                            name="user"
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Ingresa tu usuario"
                                                            onChange={this.handleChange}
                                                            value={this.state.user}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label className="login-form__label">Contraseña</label>
                                                    <div className="input-group">
                                                        <input
                                                            required
                                                            name="password"
                                                            type={this.state.showPassword ? "text" : "password"}
                                                            className="form-control"
                                                            placeholder="Ingresa tu contraseña"
                                                            onChange={this.handleChange}
                                                            value={this.state.password}
                                                        />
                                                        <button
                                                            type="button"
                                                            className="btn btn-link"
                                                            onClick={this.togglePasswordVisibility}
                                                        >
                                                            {IconEye(this.state.showPassword)}
                                                        </button>
                                                    </div>
                                                </div>

                                                {showInputMFaHabilitado && (
                                                    <div className="form-group">
                                                        <div className="col-12">
                                                            <label className="login-form__label">Código de autenticación</label>
                                                            <input
                                                                required
                                                                name="codigoDobleAutenticacion"
                                                                type="text"
                                                                className={`form-control ${this.state.errorCodigoMfa ? "is-invalid" : ""}`}
                                                                placeholder="Ingresá el código de 6 dígitos"
                                                                onChange={this.handleChange}
                                                                maxLength={6}
                                                                value={codigoDobleAutenticacion}
                                                            />
                                                            {this.state.errorCodigoDobleAutenticacion && (
                                                                <small className="text-danger">{this.state.errorCodigoDobleAutenticacion}</small>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}

                                                {this._SolveReCaptcha && Boolean(this.props.googleReCaptchaProps?.executeRecaptcha) &&
                                                    <GoogleReCaptcha
                                                        onVerify={this.handleVerifyReCaptcha}
                                                    />
                                                }

                                                <div className="form-group text-center">
                                                    {(showSpinner) ? <MiniSpinner /> :
                                                        <div>
                                                            <div className="d-block mt-3">
                                                                <button
                                                                    onClick={this.onLogin}
                                                                    className="btn btn-block background-rojo-megatone w-75"
                                                                    type="submit"
                                                                >
                                                                    Entrar
                                                                </button>
                                                            </div>

                                                            <div className="d-block mt-2">
                                                                <button
                                                                    type="button"
                                                                    onClick={() => this.setState({ recoverPassword: true })}
                                                                    className="btn btn-link w-75"
                                                                >
                                                                    Recuperar contraseña
                                                                </button>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>

                                            </>
                                        )}
                                    </div>

                                    :

                                    <div className="login-recovery-card">
                                        <div className="form-group">
                                            <div className="col-12">
                                                <label className="login-form__label">Email del usuario</label>
                                                <input
                                                    required
                                                    name="email"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Email del usuario"
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                        </div>

                                        <div className="form-group p-1 text-center">
                                            <div className="col-12">
                                                {showSpinner ? (
                                                    <MiniSpinner />
                                                ) : (
                                                    <button
                                                        type="button"
                                                        onClick={this.onRequestToken}
                                                        className="btn btn-block btn-large background-rojo-megatone rounded-sm"
                                                    >
                                                        Solicitar nueva contraseña
                                                    </button>
                                                )}
                                            </div>
                                        </div>

                                        <div className="text-center mt-2">
                                            <button
                                                type="button"
                                                className="btn btn-link btn-sm"
                                                onClick={() => this.setState({ recoverPassword: false })}
                                            >
                                                Volver al inicio de sesión
                                            </button>
                                        </div>

                                    </div>
                                }
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}


// Wrapper para usar hooks en class component y el Provider de ReCaptcha
const LoginWithRecaptcha = withGoogleReCaptcha(Login);

const LoginWrapper = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    return <LoginWithRecaptcha {...props} navigate={navigate} location={location} />;
};

const mapStateToProps = state => ({
    userType: state.general.userType,
    userId: state.general.userId
});

// Exportar versión sin reCAPTCHA para fallback cuando no hay Provider
export const LoginBase = connect(mapStateToProps, {
    fetchTokenResetPassword,
    setAuthenticated,
    setIdSeller,
    setUserName,
    setUserCredenciales,
    setMfaStatus,
})(Login);

export default connect(mapStateToProps, {
    fetchTokenResetPassword,
    setAuthenticated,
    setIdSeller,
    setUserName,
    setUserCredenciales,
    setMfaStatus,
})(LoginWrapper);
